'use strict';

var chartDefaults = require('controllers/chart_defaults');
var externalTooltipHandler = chartDefaults.externalTooltipHandler;

$(document).on('turbolinks:load', function () {
  if (window.Janreco.currentPath().match(/^\/players\/\d+$/)) {
    [4, 3].forEach(function (playType) {
      initWindRadarChart(playType);
      initOpponentChart(playType);
    });
  }

  if (window.Janreco.currentPath().match(/^\/players\/\d+\/result_by_players$/)) {
    initOpponentChart('all');
    initResultByPlayersToggle();
  }
});

// 家別成績レーダーチャート
function initWindRadarChart(playType) {
  var canvas = document.getElementById('wind-radar-chart-' + playType);
  if (!canvas) return;

  // 既に初期化済みならスキップ
  if (canvas._windRadarChart) return;

  var rawData = canvas.getAttribute('data-radardata');
  var chartPlayType = parseInt(canvas.getAttribute('data-playtype'), 10);
  if (!rawData) return;

  var radarData = JSON.parse(rawData);
  var windLabelColors = { 1: '#D35B4B', 2: '#E8A735', 3: '#4A7FB5', 4: '#8B6BAE' };
  var maxRank = chartPlayType;

  // ロケール依存の文言はdata属性経由でHAMLから受け取る
  var rankFormat = canvas.getAttribute('data-rank-format') || '{n}';
  var avgRankLabel = canvas.getAttribute('data-avg-rank-label') || '';
  var noDataLabel = canvas.getAttribute('data-no-data') || '';
  function formatRank(value) { return rankFormat.replace('{n}', value); }

  var labels = radarData.map(function (d) { return d.name || ''; });

  var roundRect = JanrecoUtils.roundRect;

  // 家ラベルを色付き角丸背景で描画するプラグイン
  var windLabelPlugin = {
    id: 'windLabel' + playType,
    afterDraw: function (chart) {
      var scale = chart.scales.r;
      var ctx = chart.ctx;

      scale.getLabels().forEach(function (label, i) {
        var pos = scale.getPointLabelPosition(i);
        var centerX = (pos.left + pos.right) / 2;
        var centerY = (pos.top + pos.bottom) / 2;
        var ie = radarData[i] ? radarData[i].ie : 0;
        var bgColor = windLabelColors[ie] || '#616168';

        var fontSize = 12;
        var paddingX = 7;
        var paddingY = 3;
        var radius = 3;

        ctx.save();
        ctx.font = 'bold ' + fontSize + 'px -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial';
        var textWidth = ctx.measureText(label).width;
        var boxW = textWidth + paddingX * 2;
        var boxH = fontSize + paddingY * 2;
        var boxX = centerX - boxW / 2;
        var boxY = centerY - boxH / 2;

        roundRect(ctx, boxX, boxY, boxW, boxH, radius);
        ctx.fillStyle = bgColor;
        ctx.fill();

        ctx.fillStyle = '#ffffff';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(label, centerX, centerY);
        ctx.restore();
      });
    }
  };

  var dataValues = radarData.map(function (d) {
    if (d.avg_rank === null || d.match_count === 0) return maxRank;
    return d.avg_rank;
  });

  canvas._windRadarChart = new Chart(canvas, {
    type: 'radar',
    data: {
      labels: labels,
      datasets: [{
        data: dataValues,
        backgroundColor: 'rgba(63, 180, 136, 0.15)',
        borderColor: '#3FB488',
        borderWidth: 2,
        pointBackgroundColor: '#ffffff',
        pointBorderColor: '#3FB488',
        pointBorderWidth: 2,
        pointRadius: 3,
        pointHoverRadius: 5
      }]
    },
    options: {
      responsive: true,
      maintainAspectRatio: true,
      layout: { padding: 14 },
      plugins: {
        legend: { display: false },
        tooltip: {
          enabled: false,
          external: externalTooltipHandler,
          callbacks: {
            title: function (items) {
              var label = items[0].label;
              return Array.isArray(label) ? label[0] : label;
            },
            label: function (context) {
              var d = radarData[context.dataIndex];
              if (d.avg_rank === null || d.match_count === 0) return noDataLabel;
              return avgRankLabel + ': ' + formatRank(d.avg_rank);
            }
          }
        }
      },
      scales: {
        r: {
          reverse: true,
          min: 1.0,
          max: maxRank,
          ticks: {
            stepSize: 1,
            display: true,
            callback: function (value) { return formatRank(value); },
            font: { size: 10 },
            color: '#808083',
            backdropColor: 'transparent'
          },
          grid: { color: 'rgba(0, 0, 0, 0.08)', circular: false },
          angleLines: { color: 'rgba(0, 0, 0, 0.08)' },
          pointLabels: {
            font: { size: 14, weight: 'bold' },
            color: 'transparent',
            padding: 12
          }
        }
      }
    },
    plugins: [windLabelPlugin]
  });

  window['redrawWindRadarChart' + playType] = function () {
    if (canvas._windRadarChart) {
      canvas._windRadarChart.destroy();
      canvas._windRadarChart = null;
    }
    initWindRadarChart(playType);
  };
}

// 対戦相手別 横棒チャート
function initOpponentChart(playType) {
  var canvas = document.getElementById('opponent-chart-' + playType);
  if (!canvas) return;

  if (canvas._opponentChart) return;

  var rawData = canvas.getAttribute('data-opponent');
  if (!rawData) return;

  var opponentData = JSON.parse(rawData);
  if (opponentData.length === 0) return;

  var getPointHeatmapColor = JanrecoUtils.getPointHeatmapColor;
  var labels = opponentData.map(function (d) { return d.name || ''; });
  var values = opponentData.map(function (d) { return d.point; });
  var barColors = values.map(function (v) { return getPointHeatmapColor(v); });

  var barHeight = 32;
  var chartHeight = Math.max(opponentData.length * barHeight + 40, 120);
  canvas.parentElement.style.height = chartHeight + 'px';

  var zeroLinePlugin = {
    id: 'opponentZeroLine' + playType,
    afterDraw: function (chart) {
      var xScale = chart.scales.x;
      var ctx = chart.ctx;
      var x = xScale.getPixelForValue(0);
      if (x >= chart.chartArea.left && x <= chart.chartArea.right) {
        ctx.save();
        ctx.strokeStyle = 'rgba(0, 0, 0, 0.25)';
        ctx.lineWidth = 1;
        ctx.setLineDash([4, 4]);
        ctx.beginPath();
        ctx.moveTo(x, chart.chartArea.top);
        ctx.lineTo(x, chart.chartArea.bottom);
        ctx.stroke();
        ctx.restore();
      }
    }
  };

  var barLabelPlugin = {
    id: 'opponentBarLabel' + playType,
    afterDatasetsDraw: function (chart) {
      var ctx = chart.ctx;
      var meta = chart.getDatasetMeta(0);
      var xScale = chart.scales.x;
      var zeroX = xScale.getPixelForValue(0);

      meta.data.forEach(function (bar, index) {
        var value = chart.data.datasets[0].data[index];
        var label = (value > 0 ? '+' : '') + value.toFixed(1);

        ctx.save();
        ctx.font = '10px -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial';
        ctx.fillStyle = '#ffffff';
        ctx.textBaseline = 'middle';

        var barWidth = Math.abs(bar.x - zeroX);
        var textWidth = ctx.measureText(label).width;

        if (barWidth > textWidth + 8) {
          ctx.textAlign = value >= 0 ? 'right' : 'left';
          var x = value >= 0 ? bar.x - 4 : bar.x + 4;
          ctx.fillText(label, x, bar.y);
        } else {
          ctx.fillStyle = '#393944';
          ctx.textAlign = value >= 0 ? 'left' : 'right';
          var x = value >= 0 ? bar.x + 4 : bar.x - 4;
          ctx.fillText(label, x, bar.y);
        }

        ctx.restore();
      });
    }
  };

  canvas._opponentChart = new Chart(canvas, {
    type: 'bar',
    data: {
      labels: labels,
      datasets: [{
        data: values,
        backgroundColor: barColors,
        borderRadius: 3,
        barThickness: 18
      }]
    },
    options: {
      indexAxis: 'y',
      responsive: true,
      maintainAspectRatio: false,
      animation: false,
      plugins: {
        legend: { display: false },
        tooltip: { enabled: false }
      },
      scales: {
        x: {
          grid: { color: 'rgba(0, 0, 0, 0.06)' },
          ticks: {
            font: { size: 10 },
            color: '#808083',
            callback: function (value) { return (value > 0 ? '+' : '') + value; }
          }
        },
        y: {
          grid: { display: false },
          ticks: { font: { size: 12, weight: 'bold' }, color: '#393944' }
        }
      }
    },
    plugins: [zeroLinePlugin, barLabelPlugin]
  });

  window['redrawOpponentChart' + playType] = function () {
    if (canvas._opponentChart) {
      canvas._opponentChart.destroy();
      canvas._opponentChart = null;
    }
    initOpponentChart(playType);
  };
}

// 対戦相手別成績ページのトグル処理
function initResultByPlayersToggle() {
  $('.opponent-list-toggle').off('click').on('click', function () {
    var $toggle = $(this);
    $toggle.next('.opponent-list').slideToggle(300);
    $toggle.find('.fa').toggleClass('fa-chevron-down fa-chevron-up');
    var $text = $toggle.find('.opponent-list-toggle-text');
    var labelShow = $toggle.data('label-show');
    var labelHide = $toggle.data('label-hide');
    if ($text.text() === labelShow) {
      $text.text(labelHide);
    } else {
      $text.text(labelShow);
    }
  });
}
